export function notesReferrerInfoForUI(info) {
  return {
    FamilyId: info.id,
    FirstName: info.name,
    LastName: '',
    Email: info.email,
    Mobile: info.mobile,
  };
}
